// extracted by mini-css-extract-plugin
module.exports = {"footer":"style__footer___3bEJV"};